import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../components/AuthContext';
import { getAuth, signOut } from 'firebase/auth';
import NotificationBell from '../../components/NotificationBell';

const NAV_LINKS = [
  { to: '/seller', label: 'Dashboard' },
  { to: '/staff/profile', label: 'Mi perfil' },
];

const SellerNavbar = () => {
  const location = useLocation();
  const { logout } = useAuth();

  const handleLogout = async () => {
    try {
      const auth = getAuth();
      await signOut(auth);
    } catch (err) {
      console.warn('No se pudo cerrar sesión en Firebase:', err.message);
    }
    logout();
  };

  return (
    <header className="bg-white border-b border-gray-200 shadow-sm px-4 sm:px-6 py-4">
      <div className="flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
        <div>
          <h1 className="text-lg font-semibold text-gray-900">Panel de Ventas</h1>
          <p className="text-sm text-gray-500">Gestiona tus leads y resultados</p>
        </div>
        <nav className="flex flex-wrap items-center gap-2 text-sm md:justify-end">
          <NotificationBell />
          {NAV_LINKS.map((link) => (
            <Link
              key={link.to}
              to={link.to}
            className={`font-medium px-3 py-2 rounded-md transition ${
              location.pathname === link.to
                ? 'bg-orange-500 text-white'
                : 'text-gray-600 hover:text-gray-900'
            }`}
          >
            {link.label}
          </Link>
        ))}
        <button
          type="button"
          onClick={handleLogout}
          className="font-medium text-gray-500 hover:text-gray-900"
        >
          Cerrar sesión
        </button>
        </nav>
      </div>
    </header>
  );
};

export default SellerNavbar;
